const StartDateIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 5.5C10.75 5.08579 10.4142 4.75 10 4.75C9.58579 4.75 9.25 5.08579 9.25 5.5V7.07926C7.81067 7.19451 6.86577 7.47737 6.17157 8.17157C5.47737 8.86577 5.19451 9.81067 5.07926 11.25H24.9207C24.8055 9.81067 24.5226 8.86577 23.8284 8.17157C23.1342 7.47737 22.1893 7.19451 20.75 7.07926V5.5C20.75 5.08579 20.4142 4.75 20 4.75C19.5858 4.75 19.25 5.08579 19.25 5.5V7.0129C18.5847 7 17.839 7 17 7H13C12.161 7 11.4153 7 10.75 7.0129V5.5Z"
      fill="#AFB1BA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 15C25 14.161 25 13.4153 24.9871 12.75H5.0129C5 13.4153 5 14.161 5 15V17C5 20.7712 5 22.6569 6.17157 23.8284C7.34315 25 9.22876 25 13 25H17C20.7712 25 22.6569 25 23.8284 23.8284C25 22.6569 25 20.7712 25 17V15ZM17 15.25C16.0335 15.25 15.25 16.0335 15.25 17V19C15.25 19.9665 16.0335 20.75 17 20.75C17.9665 20.75 18.75 19.9665 18.75 19V17C18.75 16.0335 17.9665 15.25 17 15.25ZM17 16.75C16.8619 16.75 16.75 16.8619 16.75 17V19C16.75 19.1381 16.8619 19.25 17 19.25C17.1381 19.25 17.25 19.1381 17.25 19V17C17.25 16.8619 17.1381 16.75 17 16.75ZM13.787 15.3071C14.0673 15.4232 14.25 15.6967 14.25 16V20C14.25 20.4142 13.9142 20.75 13.5 20.75C13.0858 20.75 12.75 20.4142 12.75 20V17.8107L12.5303 18.0303C12.2374 18.3232 11.7626 18.3232 11.4697 18.0303C11.1768 17.7374 11.1768 17.2626 11.4697 16.9697L12.9697 15.4697C13.1842 15.2552 13.5068 15.191 13.787 15.3071Z"
      fill="#AFB1BA"
    />
  </svg>
);

export default StartDateIcon;
